<!-- 联系我们 -->
<template>
  <div class='template-container'>
    <div class="template-content">
      <div class="section section-link">
        <h1 class="right-title"> {{ $t("support.text1") }}</h1>
        <div class="right-desc">{{ $t("support.text2") }}</div>
        <router-link class="link-main"
                     to="/contactUs">
          <span>{{ $t("support.text3") }}</span>
          <img src="/static/images/about/about/arrow.png"
               alt="箭头">
        </router-link>
      </div>
      <div class="section section-img">
        <img src="/static/images/about/after/c1.jpg"
             alt="帮助与支持">
      </div>
      <div class="section section2-main">
        <h2 class="section2-title">{{ $t("support.text4") }}</h2>
        <div class="section2-content">
          <div class="content-top">
            <div class="top-left">{{ $t("support.text5") }}</div>
            <div class="top-right">
              <!-- <div class="contact-main">
                <img class="contact-img"
                     src="/static/images/about/contact/tel.png"
                     alt="telphone"><span class="contact-text">17133852627（微信同号）</span>
              </div> -->
              <div class="contact-main" style="margin-top: 40px;">
                <img class="contact-img"
                     src="/static/images/about/contact/mail.png"
                     alt="email"><span class="contact-text">shouhoufuwu@hovwing.com</span>
              </div>
            </div>
          </div>
          <div class="content-middle">
            <div class="middle-left">
              <img src="/static/images/about/contact/map.jpg"
                   alt="地图 map">
            </div>
            <div class="middle-right">
              <h2 class="right-title">{{ $t("support.text6") }}</h2>
              <div class="right-desc">{{ $t("support.text7") }}</div>
            </div>
          </div>
          <div class="content-bottom" v-if="$i18n.locale == 'zh_CN'">
            <img src="/static/images/about/after/banner3.png"
                 alt="图标集合">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    };
  }
};
</script>

<style lang='stylus' scoped>
.template-container {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  background: #fff;

  .template-content {
    width: 80%;
    max-width: 1280px;
    margin: 0 auto;

    .section {
      padding-top: 80px;
    }

    .section-link {
      .right-title {
        font-size: 48px;
        color: #111111;
        line-height: 22px;
        padding: 40px 0;
        text-align: center;
      }

      .right-desc {
        max-width: 628px;
        margin: 0 auto;
        font-size: 24px;
        color: #444444;
        line-height: 42px;
        padding: 20px 0;
        text-align: center;
      }

      .link-main {
        display: block;
        width: 400px;
        border-radius: 6px;
        border: 2px solid #EBEBEB;
        font-size: 20px;
        color: #111111;
        line-height: 40px;
        padding: 20px 0;
        margin: 20px auto;
        cursor: pointer;

        span, img {
          vertical-align: top;
        }

        span {
          padding-left: 74px;
          padding-right: 10px;
        }
      }
    }

    .section-img {
      img {
        width: 100%;
      }
    }

    .section2-main {
      padding-bottom: 100px;

      .section2-title {
        font-size: 48px;
        color: #111111;
        line-height: 75px;
        padding-bottom: 40px;
        text-align: center;
      }

      .section2-content {
        .content-top {
          display: flex;
          border: 1px solid #EBEBEB;

          .top-left {
            flex: 1;
            font-size: 36px;
            color: #111111;
            line-height: 120px;
            text-align: center;
            border-right: 1px solid #EBEBEB;
            margin: 40px 0;
          }

          .top-right {
            flex: 1;

            .contact-main {
              display: flex;
              padding-left: 40px;
              padding-top: 40px;

              .contact-img {
                width: 40px;
                height: 40px;
                margin-left: 40px;
                margin-right: 20px;
              }

              .contact-text {
                font-size: 24px;
                line-height: 40px;
              }
            }
          }
        }

        .content-middle {
          padding-top: 50px;
          display: flex;

          .middle-left {
            width: 540px;

            img {
              width: 100%;
            }
          }

          .middle-right {
            flex: 1;
            padding: 40px;

            .right-title {
              font-size: 24px;
              color: #111111;
              line-height: 22px;
              padding-bottom: 20px;
            }

            .right-desc {
              font-size: 20px;
              color: #444444;
              line-height: 42px;
            }
          }
        }

        .content-bottom {
          max-width: 1080px;
          margin: 0 auto;
          padding-top: 180px;
          padding-bottom: 80px;

          img {
            width: 100%;
          }
        }
      }
    }
  }
}

@media all and (min-width: 769px) and (max-width: 1400px) {
  // 0.4 ~ 0.75
  .template-container {
    .template-content {
      .section-link {
        .right-title {
          font-size: 36px;
        }

        .link-main {
          width: 350px;
          border-radius: 4px;
          border: 2px solid #EBEBEB;
          font-size: 16px;
          line-height: 40px;

          span, img {
            vertical-align: top;
          }

          span {
            padding-left: 54px;
            padding-right: 10px;
          }
        }
      }

      .section2-main {
        .section2-title {
          font-size: 32px;
        }

        .section2-content {
          .content-top {
            .top-left {
              font-size: 24px;
              line-height: 80px;
              margin: 20px 0;
            }

            .top-right {
              .contact-main {
                padding-left: 20px;
                padding-top: 20px;

                .contact-img {
                  width: 30px;
                  height: 30px;
                  margin-left: 20px;
                  margin-right: 20px;
                }

                .contact-text {
                  font-size: 24px;
                  line-height: 30px;
                }
              }
            }
          }

          .content-middle {
            .middle-left {
              width: 480px;

              img {
                width: 100%;
              }
            }

            .middle-right {
              flex: 1;
              padding: 20px;

              .right-title {
                font-size: 20px;
                line-height: 30px;
                padding-bottom: 20px;
              }

              .right-desc {
                font-size: 16px;
                color: #444444;
                line-height: 32px;
              }
            }
          }

          .content-bottom {
            max-width: 1080px;
            margin: 0 auto;
            padding: 80px 0;

            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
}

@media all and (min-width: 769px) and (max-width: 1400px) {
  .section2-main {
    .section2-content {
      .content-middle {
        .middle-left {
          width: 400px !important;
        }
      }
    }
  }
}

// 移动端
@media all and (min-width: 320px) and (max-width: 768px) {
  .template-container {
    .template-content {
      width: 100%;

      .section-link {
        .right-title {
          font-size: 32px;
          line-height: 42px;
          padding: 20px;
        }

        .right-desc {
          font-size: 16px;
          line-height: 32px;
          padding: 10px 20px;
        }

        .link-main {
          width: calc(100% - 40px);
          font-size: 16px;
          color: #111111;
          line-height: 40px;
          padding: 20px 0;
          margin: 20px auto;
          cursor: pointer;

          span, img {
            vertical-align: top;
          }

          span {
            padding-left: 54px;
            padding-right: 10px;
          }
        }
      }

      .section2-main {
        padding-bottom: 80px;

        .section2-title {
          font-size: 32px;
          line-height: 42px;
          padding-bottom: 20px;
          padding-left: 20px;
          padding-right: 20px;
        }

        .section2-content {
          .content-top {
            display: block;

            .top-left {
              font-size: 24px;
              line-height: 60px;
              border-right: none;
              margin: 0;
              text-align: left;
              padding-left: 25px;
            }

            .top-right {
              .contact-main {
                display: block;
                padding: 0;

                .contact-img {
                  width: 30px;
                  height: 30px;
                  margin-left: 20px;
                  margin-right: 20px;
                  vertical-align: top;
                }

                .contact-text {
                  font-size: 24px;
                  line-height: 30px;
                  vertical-align: top;
                }
              }
            }
          }

          .content-middle {
            padding-top: 50px;
            display: block;

            .middle-left {
              width: calc(100% - 40px);
              margin: 0 auto;
            }

            .middle-right {
              padding: 20px;

              .right-title {
                font-size: 24px;
              }

              .right-desc {
                font-size: 16px;
                line-height: 32px;
              }
            }
          }

          .content-bottom {
            max-width: 1080px;
            margin: 0 auto;
            padding: 40px 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about/after.vue